import React, {Component} from 'react'
import {Button, Modal, notification, Input} from 'antd'
import PropTypes from 'prop-types'
import {ObjectInspector} from 'react-inspector'
import {bulkMarkPrintedOrderByIds} from "../../../../../services/api/3dApi"

const {TextArea} = Input

class BulkMarkAsPrinted extends Component {
    state = {
        isOpen: true,
    }

    _ids = ''

    _handleChange = e => {
        const {value} = e.target

        this._ids = value
    }

    _handleSubmit = e => {
        e.preventDefault()

        this._markAsPrinted()
    }

    _markAsPrinted = async () => {
        try {
            this.setState({loading: true})

            const payload = {
                templates: this._ids,
            }

            const {data: response} = await bulkMarkPrintedOrderByIds(payload)

            const {success, error, data} = response

            if (!success) {
                throw new Error(error)
            }

            const {error: importError = 0, errorOrders} = data

            if (importError > 0) {
                notification['success']({
                    message: 'Form submit successfully!',
                    description: <div>
                        <div className='mb-2'>Some template is invalid</div>
                        <ObjectInspector data={errorOrders} expandLevel={2}/>
                    </div>,
                    duration: 0,
                })
            } else {
                notification['success']({
                    message: 'Form submit successfully!',
                    duration: 1,
                })
            }

        } catch (e) {
            notification['error']({
                message: `ERROR: ${e.message}`,
                duration: 0,
            })
        }
    }

    _renderModalFooter = () => {
        const buttonCancel = <Button key='btnCancelBulkAction2' onClick={this._closeModal}>Cancel</Button>
        const buttonOk = <Button key='btnOKBulkAction2' type='primary' onClick={this._handleSubmit}>OK</Button>

        return [buttonCancel, buttonOk]
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleAfterClose = () => {
        this.props.onResetAction()
    }

    render() {
        const {isOpen} = this.state
        const modalFooter = this._renderModalFooter()

        return (
            <Modal visible={isOpen} title='Mark as printed' footer={modalFooter} className='BulkMarkAsPrinted'
                   afterClose={this._handleAfterClose} onCancel={this._closeModal}>
                <label htmlFor='listTemplateIds' className='fs-16'>
                    Enter filename (includes ".tif") separated by enter.
                </label>
                <TextArea rows={6} onChange={this._handleChange} placeholder='148608-1-M-1-1.tif'/>
            </Modal>
        )
    }
}

BulkMarkAsPrinted.propTypes = {
    onResetAction: PropTypes.func.isRequired,
}

export default BulkMarkAsPrinted
